import { render, staticRenderFns } from "./ReceiptOfWalkie.vue?vue&type=template&id=32d968d0&scoped=true&"
import script from "./ReceiptOfWalkie.vue?vue&type=script&lang=js&"
export * from "./ReceiptOfWalkie.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptOfWalkie.vue?vue&type=style&index=0&id=32d968d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d968d0",
  null
  
)

export default component.exports